"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIImpl = exports.TableauDialogError = exports.DialogMessageEvent = void 0;
const Contract = require("@tableau/api-external-contract-js");
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const TableauEvent_1 = require("../Events/TableauEvent");
const ServiceRegistryUtil_1 = require("../Services/ServiceRegistryUtil");
class DialogMessageEvent extends TableauEvent_1.TableauEvent {
    constructor(message, sourceDialogUrl) {
        super(Contract.TableauEventType.DialogMessageReceived);
        this.message = message;
        this.sourceDialogUrl = sourceDialogUrl;
    }
}
exports.DialogMessageEvent = DialogMessageEvent;
/**
 * Custom error class that extends the TableauError object.
 * Includes context for which dialog caused the exception via its url.
 */
class TableauDialogError extends api_shared_js_1.TableauError {
    constructor(_errorCode, message) {
        super(_errorCode, message);
        /*tslint:disable-next-line */
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // Error inheritance does not work propertly when compiling to ES5, this is a workaround to force
        // the proto chain to be built correctly.  See the github link above for details.
        Object.setPrototypeOf(this, TableauDialogError.prototype);
    }
}
exports.TableauDialogError = TableauDialogError;
class UIImpl {
    constructor(isExtensionDialog) {
        this.isExtensionDialog = isExtensionDialog;
    }
    displayDialogAsync(url, payload, options) {
        const uiService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("UIService" /* ExtensionsServiceNames.UIService */);
        const notificationService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("notification-service" /* ServiceNames.Notification */);
        return new Promise((resolve, reject) => {
            uiService
                .displayDialogAsync(url, payload || '', this.isExtensionDialog, options)
                .then(() => {
                const unregisterFn = notificationService.registerHandler(api_internal_contract_js_1.NotificationId.ExtensionDialogUpdate, () => {
                    // Let through any dialog update event
                    return true;
                }, (event) => {
                    if (event.isCloseEvent) {
                        if (event.closePayload === undefined) {
                            throw new TableauDialogError(Contract.ErrorCodes.InternalError, 'closePayload is undefined');
                        }
                        resolve(event.closePayload);
                    }
                    else {
                        reject(new TableauDialogError(api_external_contract_js_1.ErrorCodes.DialogClosedByUser, 'Extension dialog closed by user.'));
                    }
                    unregisterFn();
                });
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    sendDialogMessageAsync(message, targetDialogUrl) {
        const uiService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("UIService" /* ExtensionsServiceNames.UIService */);
        uiService.sendDialogMessageAsync(message, targetDialogUrl);
    }
    sendDialogMessageToParentAsync(message) {
        if (!this.isExtensionDialog) {
            throw new api_shared_js_1.TableauError(api_external_contract_js_1.ErrorCodes.InternalError, 'sendDialogMessageToParentAsync can only be called from an extension dialog.');
        }
        const uiService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("UIService" /* ExtensionsServiceNames.UIService */);
        uiService.sendDialogMessageToParentAsync(message);
    }
    closeDialog(payload, dialogUrl) {
        const uiService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("UIService" /* ExtensionsServiceNames.UIService */);
        uiService.closeDialog(payload, dialogUrl);
    }
    /**
     * Initializes all events relevant to UI object.
     *
     * @returns {Array<SingleEventManager>} Collection of event managers to pass to an EventListenerManager.
     */
    initializeEvents() {
        const results = new Array();
        let notificationService;
        try {
            notificationService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("notification-service" /* ServiceNames.Notification */);
        }
        catch (e) {
            // If we don't have this service registered, just return
            return results;
        }
        const dialogMessageEvent = new api_shared_js_1.SingleEventManagerImpl(Contract.TableauEventType.DialogMessageReceived);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.ExtensionDialogMessage, () => true, (event) => {
            dialogMessageEvent.triggerEvent(() => new DialogMessageEvent(event.message, event.sourceDialogUrl));
        });
        results.push(dialogMessageEvent);
        return results;
    }
}
exports.UIImpl = UIImpl;
//# sourceMappingURL=UIImpl.js.map